import react from 'React';
import {Tooltip as ReactTooltip} from 'react-tooltip';
import { getPublishedStatus } from  '@/helpers/Content';


const FoundInPublishedStatus = ({contentStatus, contentId}: { contentStatus: any, contentId:number }) => {
    const status = getPublishedStatus(contentStatus);
    return (
        <div className="content-status-container" data-tooltip-id={`tooltip-status-code-${contentId}`} data-tooltip-content={status}>
            <span className={`content-status-icon ${status?.split(' ').join('-')}`} />
            
            <span className="sr-only">{status}</span>

            <ReactTooltip id={`tooltip-status-code-${contentId}`} place="top" className="thrive-tooltip no-width" aria-hidden="true" />
        </div>
    );
};

export default FoundInPublishedStatus;